import React from 'react'

const Contact = () => {
  return (
    <section id="contato">
      <div className="contato-content">
        <div className="section-title">
          <h2>Nosso Contato</h2>
        </div>

        <p>
          <i
            className="fas fa-location-dot"
            style={{ color: 'var(--primary)', marginRight: '10px' }}
          ></i>
          Naviraí/MS
        </p>
        <p>
          <strong>Laboratório de Tecnologia Agrícola</strong>
        </p>

        <div className="contact-links">
          <a href="tel:67996827712">
            <i className="fas fa-phone-alt"></i> (67) 9 9682-7712
          </a>
          <a href="tel:67981414278">
            <i className="fas fa-phone-alt"></i> (67) 9 8141-4278
          </a>
        </div>

        <a
          href="https://wa.me/5567981414278"
          className="btn"
          style={{ width: '100%', textAlign: 'center' }}
        >
          Falar com um Técnico agora
        </a>
      </div>

      <div className="contato-content">
        <div className="map-placeholder">
          <h2>Nossa Localização</h2>
          <p>
            Rua: Av. Brasil, 1202 - Centro <br />
            Naviraí MS - CEP: 79950-000
          </p>

          <i>Clique abaixo para visualizar o Mapa</i>
          <br />
          <a
            href="https://maps.google.com/"
            className="btn btn-primary"
            target="_blank"
            rel="noreferrer"
          >
            Abrir no Google Maps
          </a>
        </div>
      </div>
    </section>
  )
}

export default Contact
